import { IconButton, Paper, Tab, Tabs } from "@mui/material";
import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Pan from "../../assets/svg/PenEtat.svg";
import UserIcon from "../../assets/svg/user 1.svg";
import defaultImage from "../../assets/svg/defultImage.svg";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CircleIcon from "@mui/icons-material/Circle";
import "./Brands.css";
import {
  BreakfastDining,
  Factory,
  InfoOutlined,
  Square,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { RightOutlined } from "@ant-design/icons";
import { Modal } from "react-bootstrap";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";

export default function BrandsProfile() {
  const newHost = "https://estbn.com/EstbnNew/public/api/";

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id } = useParams();

  const [brandInfo, setBrandInfo] = useState(null);

  const [showActivate, setShowActivate] = useState(false);

  const [categories, setCategories] = useState([]);

  const [products, setProducts] = useState([]);

  const navigate = useNavigate();

  const goToProduct = (proId) => {
    navigate(`/brands/${id}/products/${proId}`);
  };

  const handleActivateShow = () => {
    setShowActivate(true);
  };

  const handleActivateClose = () => {
    setShowActivate(false);
  };

  const getBrandById = async () => {
    try {
      const response = await axios.get(`${newHost}portal/brands/${id}`, {
        headers: newHeaders,
      });
      console.log(response.data.data);
      setBrandInfo(response.data.data.brand);
      setProducts(response.data.data.brand.all_products);
      setCategories(response.data.data.brand.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const activateCategories = async () => {
    const isActive = brandInfo?.status === "active";
    const newStatus = isActive ? "inactive" : "active";

    try {
      const response = await axios.post(
        `${newHost}portal/brands/${id}`,
        {
          _method: "PATCH",
          status: newStatus,
        },
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      getBrandById();
      setShowActivate(false);
    } catch (error) {
      console.log(error);
    }
  };

  const [selectedProductId, setSelectedProductId] = useState(null);

  const handleTabChange = (event, newValue) => {
    setSelectedProductId(newValue);
  };

  const filteredProducts = useMemo(() => {
    return products.filter((product) => {
      const matchesProducts =
        selectedProductId === null ||
        product.category?.id === selectedProductId;

      return matchesProducts;
    });
  }, [products, selectedProductId]);

  const rows = filteredProducts.map((product) => ({
    id: product.id,
    Name: product.sku,
    Unit: product.unit?.name,
    Quantity: product.quantity,
    Reorder: product.reorder_point,
    Status: product.status,
    Actions: "",
    rawData: product,
  }));

  const columns = [
    {
      field: "Name",
      headerName: "Product Name",
      flex: 0.9,
      minWidth: 110,
    },
    {
      field: "Unit",
      headerName: "Unit",
      flex: 0.6,
      minWidth: 80,
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      flex: 0.6,
      minWidth: 80,
    },
    { field: "Reorder", headerName: "Reorder Point", flex: 0.9, minWidth: 120 },
    { field: "Status", headerName: "Status", flex: 0.8, minWidth: 100 },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.5,
      minWidth: 50,
      renderCell: (params) => {
        // const brand = params.row.rawData;
        const handleNavigate = (e) => {
          e.stopPropagation();
          console.log("Navigate to:", params.row.id);
          goToProduct(params.row.id);
        };

        return (
          <>
            <IconButton onClick={handleNavigate} color="default" size="small">
              <RightOutlined />
            </IconButton>
          </>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  useEffect(() => {
    getBrandById();
  }, []);

  return (
    <>
      <Modal show={showActivate} onHide={handleActivateClose} className="">
        <>
          <div className="text-center py-4">
            {" "}
            <h3>Confirm Deletion</h3>
          </div>
          <div className="text-center py-2  px-3">
            <h6 style={{ color: "#535353" }} className="fs-4">
              Are you sure you want to{" "}
              {brandInfo?.status === "active" ? "inactivate" : "activate"}{" "}
              <span className="fw-bold d-block">{brandInfo?.name} brand?</span>
            </h6>
          </div>
          <div>
            <div className="d-flex justify-content-center align-items-center gap-3 py-3">
              <button
                onClick={handleActivateClose}
                className="btn btn-light px-5"
              >
                Cancel
              </button>
              <button
                onClick={activateCategories}
                className={`btn  ${
                  brandInfo?.status === "active" ? "btn-danger" : "btn-success"
                } px-5`}
              >
                {brandInfo?.status === "active"
                  ? "Inactivate Brand"
                  : "Activate Brand"}
              </button>
            </div>
          </div>
        </>
      </Modal>
      <div className="min-vh-100 mx-4 my-3">
        {/* profile head */}
        <div className="row align-items-center mb-1">
          <div className="col-12 col-lg-4 col-xl-3 mb-2 mb-md-0">
            <h5 className="fw-semibold">Brand Profile</h5>
          </div>
          {/* tabs and activation  */}
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
              {/* Tabs Section */}
              <div
                className="bg-light rounded-3 d-flex align-items-center mb-3"
                style={{
                  width: "100%",
                  overflowX: "auto",
                  WebkitOverflowScrolling: "touch",
                  height: "40px",
                }}
              >
                <Tabs
                  value={selectedProductId}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  aria-label="brand category tabs"
                  sx={{
                    minHeight: "40px",
                    height: "40px",
                  }}
                  slotProps={{
                    indicator: {
                      sx: { backgroundColor: "transparent" },
                    },
                  }}
                >
                  <Tab
                    key="all"
                    label={
                      <span className="tab-label">
                        All{" "}
                        <span className="circle">
                          {brandInfo?.total_variations}
                        </span>
                      </span>
                    }
                    value={null}
                    sx={{
                      minHeight: "40px",
                      height: "40px",
                      padding: "0 16px",
                    }}
                  />

                  {categories.map((category) => (
                    <Tab
                      key={category.id}
                      label={
                        <span className="tab-label">
                          {category.name}
                          <span className="circle">
                            {category.variations_count}
                          </span>
                        </span>
                      }
                      value={category.id}
                      sx={{
                        minHeight: "40px",
                        height: "40px",
                        padding: "0 16px",
                      }}
                    />
                  ))}
                </Tabs>
              </div>
              {/* Button */}
              <div className="text-md-end w-100 w-md-auto my-3 my-md-0">
                <button
                  onClick={handleActivateShow}
                  className={`btn ${
                    brandInfo?.status === "active"
                      ? "btn-danger"
                      : "btn-success"
                  } px-3 py-2`}
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  {brandInfo?.status === "active"
                    ? "Inactivate Brand"
                    : "Activate Brand"}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Profile Body */}
        <div className="row">
          {/* Side Card */}
          <div className="col-12 col-lg-4 col-xl-3 ">
            <div className="border border-2 rounded-3 p-3 h-100">
              <div className="supplier_Card">
                <div className="bg-light rounded-4 position-relative text-center px-3 py-2">
                  <div className="supplier_imgHulder">
                    <img
                      src={
                        brandInfo?.logo_path
                          ? `https://estbn.com/EstbnNew/public${brandInfo?.logo_path}`
                          : defaultImage
                      }
                      alt="Profile"
                      className="img-fluid"
                    />
                  </div>
                  <div className="categoryImg">
                    <img src={Pan} className="w-75" alt="" />
                  </div>
                </div>

                <div className="my-3 text-center">
                  <h5 className="fw-bold">{brandInfo?.name}</h5>
                </div>

                <div className="stuffprofileinfo_supplierProfile">
                  <div className="agentInfo-Supp">Category Info</div>
                  <div className="memberInfoItem">
                    <img
                      className="suppInfoItem_img"
                      src={UserIcon}
                      alt="user Icon"
                    />
                    <div className="memberInfotext_supplier">
                      {brandInfo?.operator?.name}
                    </div>
                  </div>
                  <div className="memberInfoItem">
                    <CalendarTodayIcon />
                    <div className="memberInfotext_supplier underlineLink">
                      Created On{" "}
                      {new Date(brandInfo?.created_at).toLocaleDateString()}
                    </div>
                  </div>
                  <div className="memberInfoItem">
                    {brandInfo?.status === "active" ? (
                      <CircleIcon fontSize="small" color="success" />
                    ) : (
                      <CircleIcon fontSize="small" />
                    )}
                    <div className="memberInfotext_supplier underlineLink">
                      {brandInfo?.status}
                    </div>
                  </div>
                  <div className="d-flex gap-2 align-items-start">
                    <InfoOutlined />
                    <p className="categoryInfo">{brandInfo?.description}</p>
                  </div>
                  <div className="d-flex gap-2 align-items-start">
                    <BreakfastDining fontSize="small" />
                    <p className="categoryInfo fw-semibold m-0">
                      {`${brandInfo?.total_variations} Products`}
                    </p>
                  </div>
                  <div className="d-flex gap-2 align-items-center my-2">
                    <Factory fontSize="small" />
                    <p className="categoryInfo fw-semibold m-0">
                      {brandInfo?.manufacturer.name}
                    </p>
                  </div>
                </div>
                <div className="stuffprofileinfo_supplierProfile">
                  <div className="agentInfo-Supp">Categories</div>
                  <div className="memberInfoItem d-flex flex-wrap gap-2">
                    {brandInfo?.categories?.map((sub) => (
                      <div
                        key={sub.name}
                        className="d-flex align-items-center gap-1"
                      >
                        <Square sx={{ fontSize: "10px", margin: 0 }} />
                        <h6 className="memberInfotext_supplier m-0">
                          {sub?.name}
                        </h6>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Table Section */}
          <div className="col-12 col-lg-8 col-xl-9">
            {filteredProducts && filteredProducts.length > 0 ? (
              <div className="scrollable-table-wrapper">
                <div>
                  <Paper sx={{ width: "100%" }}>
                    <DataGrid
                      rows={rows}
                      columns={columns}
                      initialState={{ pagination: { paginationModel } }}
                      pageSizeOptions={[5, 10]}
                      checkboxSelection
                      sx={{ border: 0 }}
                      slotProps={{
                        pagination: {
                          sx: {
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                          },
                        },
                      }}
                    />
                  </Paper>
                </div>
              </div>
            ) : (
              <div
                className="d-flex justify-content-center align-items-center w-100"
                style={{ minHeight: "300px" }}
              >
                <NotFound paragraphText="No Products yet. All your Products will appear here once you get started." />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
